/**
 * Immutably modify map
 * @param map
 * @param modifier
 */
export function modifyMap<T>(
  map: { [key: string]: T },
  modifier: (path: T, key: string) => T
) {
  const output: { [key: string]: T } = {};
  Object.entries(map || {}).forEach(([key, val]) => {
    output[key] = modifier(val, key);
  });
  return output;
}
